import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNetworkStore } from '@shared/network';
import { NetworkBanner } from '@shared/ui';

export function NetworkSync() {
  const qc = useQueryClient();
  const status = useNetworkStore((s) => s.status);
  const markBrowserOnline = useNetworkStore((s) => s.markBrowserOnline);
  const markBrowserOffline = useNetworkStore((s) => s.markBrowserOffline);
  const setStatus = useNetworkStore((s) => s.setStatus);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (navigator.onLine === false) {
      setStatus('offline');
    }

    const handleOnline = () => markBrowserOnline();
    const handleOffline = () => markBrowserOffline();

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [markBrowserOnline, markBrowserOffline, setStatus]);

  useEffect(() => {
    if (status === 'reconnected') {
      qc.invalidateQueries();
    }
  }, [status, qc]);

  const handleRetry = async () => {
    await qc.refetchQueries({ type: 'active' });
  };

  return <NetworkBanner onRetry={handleRetry} />;
}
